import { render, staticRenderFns } from "./cardbalance.vue?vue&type=template&id=b4ce58f2&scoped=true&"
import script from "./cardbalance.vue?vue&type=script&lang=js&"
export * from "./cardbalance.vue?vue&type=script&lang=js&"
import style0 from "./cardbalance.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cardbalance.vue?vue&type=style&index=1&id=b4ce58f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ce58f2",
  null
  
)

export default component.exports